import * as TemplateTypes from 'types/template.types';
import * as GameTypes from 'types/game.types';
import { Achievement } from "types/template.types";

//Tracking for achievements that occur over multiple matches
interface CrossGameStats {

}

//Tracking for individual matches
interface InGameStats {

}

//Generate default tracking stats
const getCrossGameStats = () : CrossGameStats => {
    return {
    }
}

//Generate 
const getInGameStats = () : InGameStats => {
    return {
    }
}

type TypedAchievement = Achievement<GameTypes.AchievementKey, CrossGameStats, InGameStats>;

const Achievements : { [key in GameTypes.AchievementKey] : TypedAchievement } = {
    default: {
        name: 'Not a Real Achievement',
        description: '',
        credits: 5,
        test: (tracking, match) => false,
        progress: (tracking, match, completed) => {
            return {
                format: TemplateTypes.AchievementProgressFormat.COUNT,
                value: 0,
                total: 1
            }
        }
    },
}

type AchievementDefinition = TemplateTypes.ValueOf<typeof Achievements>

export {
    CrossGameStats,
    InGameStats,
    AchievementDefinition,
    Achievements, 
    getCrossGameStats, 
    getInGameStats
};